export const memberNumberDisplayStates = {
  ON: "On",
  OFF: "Off",
};

export const memberNumberTealiumLabel = "login-with-member-contact-next-with-difficulties";
